import React from 'react';
import json from './block.js';
import AgentSearch from './AgentSearch.js';

var AgentSearchBlock = {
  Component: function Component(_ref) {
    var attrs = _ref.attrs;
    var _attrs$search = attrs.search,
      search = _attrs$search === void 0 ? 'zip' : _attrs$search,
      _attrs$placeholder = attrs.placeholder,
      placeholder = _attrs$placeholder === void 0 ? 'Enter Zip Code' : _attrs$placeholder;
    return /*#__PURE__*/React.createElement(AgentSearch, {
      search: search,
      placeholder: placeholder
    });
  },
  metadata: json
};

export { AgentSearchBlock as default };
